import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CeilingFan = createSvgIcon(
  <path d="M16.5 0v2.25h-3.375V12h1.652l2.473 2.968V15H24v2.25h-6.75v2.25h-.75a4.5 4.5 0 1 1-9 0h-.75v-2.25H0V15h6.75v-.032L9.223 12h1.652V2.25H7.5V0h9ZM9 15.782v1.468h6v-1.468l-1.277-1.532h-3.446L9 15.782Zm.75 3.718a2.25 2.25 0 0 0 4.5 0h-4.5Z" />,
  'CeilingFan'
);

export { CeilingFan };